"use strict";

let variation;

const initExperiment = (
  exp_id,
  iteration = "v0.01",
  force_activate_variation
) => {
  let exp_handle = exp_id.replace("-", "").toLowerCase();

  if (force_activate_variation) {
    variation = force_activate_variation;
  } else {
    if (getParam("qa").indexOf(exp_handle) > -1) {
      variation = getParam("qa").replace(exp_handle, "");
    } else {
      variation = window.sessionStorage.getItem(exp_id);
    }
  }

  let exp_tag = exp_handle + variation;
  document.documentElement.classList.add(exp_tag);
  console.log(`init ${exp_id}${variation} -- ${iteration}`);

  return variation;
};

function waitForElement(selector) {
  return new Promise(function (resolve, reject) {
    var element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for (var node of nodes) {
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}

// shim layer with setTimeout fallback
const requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 3000 / 60);
    }
  );
})();

function waitUntil(test) {
  return new Promise(function (resolve) {
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
}

const observeSelector = (
  selector,
  callback,
  options = {
    timeout: null,
    once: false,
    onTimeout: null,
    document: window.document,
  }
) => {
  let processed = new Map();

  if (options.timeout || options.onTimeout) {
    console.log(
      "------------------------------------------------------------------------------------------------------------------------------"
    );
    console.log(
      "WARNING: observeSelector options timeout and onTimeout are not yet implemented."
    );
    console.log(
      "------------------------------------------------------------------------------------------------------------------------------"
    );
  }

  let obs,
    isDone = false;
  const done = () => {
    if (!obs) console.warn("observeSelector failed to run done()");
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return (isDone = true);
  };

  const processElement = (el) => {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };

  const lookForSelector = (el = document) => {
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      const elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (processElement(el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    obs = new MutationObserver((mutationsList) => {
      mutationsList.forEach((record) => {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (let i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            const el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  }

  return () => {
    done();
  };
}; //_observeSelector

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const setCookie = (name, value, expdays) => {
  const d = new Date();
  d.setTime(d.getTime() + expdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const delCookie = (name, path, domain) => {
  if (getCookie(name)) {
    document.cookie =
      name +
      "=" +
      (path ? ";path=" + path : "") +
      (domain ? ";domain=" + domain : "") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
};

//-----------

const getParam = (name, optSearch) => {
  "use strict";
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(optSearch);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

//-----------

const js_loadScript = (url, optCallback) => {
  "use strict";
  const ga = document.createElement("script");
  ga.type = "text/javascript";
  ga.async = true;
  ga.src = url;
  if (typeof optCallback === "function") {
    ga.onload = optCallback;
  }
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(ga, s);
};

//----

const cart_remove_item = (var_id) => {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        id: var_id,
        quantity: 0 // Set quantity to 0 to remove the item
    })
  })
  .then(response => response.json())
  .then(cart => {
    console.log('Item removed', cart);
    // Update the UI here to reflect the removal
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};

const cart_add_item = (var_id, qty, callback, properties_object = {}) => {
  console.log(`cart_add_item(${var_id}, ${qty})`);

  const atc_data = {
    id: var_id,
    quantity: qty,
    ...(Object.keys(properties_object).length > 0 && { properties: properties_object }),
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(atc_data)
  })
  .then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(callback)
  .catch(error => console.error('Add to cart error:', error));
};


const get_cart_json = () => {
  // console.log(`get_cart_json()`);
  return $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (data) {
      // return data;
    },
  });
};

const cart_contains_subscription = () => {
  return get_cart_json().then((data) => {
    for (let i = 0; i <= data.items.length; i++) {
      if (i === data.items.length) {
        // console.log('no subs found', i);
        return false;
      } else {
        if (
          data.items[i].properties &&
          data.items[i].properties.shipping_interval_frequency
        ) {
          // console.log("subs found in item", i);
          return true;
        } else {
          // console.log('has properties, not sub tho', i);
        }
      }
    }
  });
};

const cart_contains_item = (var_id) => {
  // console.log(`cart_contains_item(${var_id})`);
  return get_cart_json().then((data) => {
    for (let i = 0; i <= data.items.length; i++) {
      if (i === data.items.length) {
        // console.log('item not found', i);
        return false;
      } else {
        if (data.items[i].variant_id === var_id) {
          // console.log("item found", i);
          return true;
        }
      }
    }
  });
};
function checkIfMobile() {
  return window.matchMedia("only screen and (max-width: 768px)").matches;
}
/*
cart_contains_item(39321012895847).then(response => {
  console.log("cart_contains_item(39321012895847)",response);
});
*/

// loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", () => {
//   console.log("jQuery re-loaded");
// }); //loadScript()

//----

waitUntil(() => {
  return typeof gtag != "undefined";
}).then(() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      'event': 'ga_configured'
  });
}).catch();


async function add_items_to_cart(items, callback) {
  console.log('add_items_to_cart()', items);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(items),
  })
    .then(response => response.json())
    .then(async (data) => {
      console.log('Item added to cart', data);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
  
      // Execute callback with cart content
      if (typeof callback === 'function') {
        callback();
      }
      
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });
}

// Example usage
/*
add_items_to_cart(
  {
    id: 44924987638001,
    quantity: 1,
    properties: { promo: 'true' },
  },
  (cartContent) => {
    console.log('Callback executed with updated cart content:', cartContent);
    let changeEvent = new Event('change', { bubbles: true });
    document.querySelector('#section--cart-items_quantity').dispatchEvent(changeEvent);
  }
);
*/

async function remove_item_from_cart(line_key, callback) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: line_key,
        quantity: 0,
      }),
    });
    
    const cart = await response.json();
    console.log('Item removed from cart', cart);
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Execute callback with cart content
    if (typeof callback === 'function') {
      callback();
    }
    
  } catch (error) {
    console.error('Error removing item from cart:', error);
  }
}

async function cart_items_w_line_prop(prop_key, action = "read") {
  try {
    // Fetch the current cart
    const response = await fetch(`/cart.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cart = await response.json();

    // Filter items that have a specific property
    const items_with_property = cart.items.filter(item => item.properties && prop_key in item.properties);

    if (action === "read") {
      // Return true if any item has the property, false otherwise
      return items_with_property.length > 0;
    } else if (action === "remove") {
      if (cart.items.length === 1) {
        // If only one item has the property, clear the cart
        const clearResponse = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          }
        });
        if (!clearResponse.ok) {
          throw new Error('Failed to clear cart');
        }
        console.log('Cart cleared.');
        // Optionally refresh the UI or notify the user
      } else {
        // Remove each item with the specified property
        for (const item of items_with_property) {
          await remove_item_from_cart(item.key);
          console.log(`Item with key ${item.key} removed.`);
          // Optionally update UI here if needed
        }
      }
    }
  } catch (error) {
    console.error('Error handling cart items:', error);
    return false; // Return false or an appropriate error message on failure
  }
}

const gtm_add_cartAttribute = (attr_name, attr_val, multiple_attr_array = [], callback) => {
    
console.log("gtm_add_cartAttribute()", attr_name, attr_val, multiple_attr_array);

// Construct the body_attributes string based on single or multiple attributes
let body_attributes = `attributes[${attr_name}]=${attr_val}`;
if (multiple_attr_array.length > 0) {
  body_attributes = multiple_attr_array.join('&');
}

fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  },
  body: body_attributes
})
.then(response => {
  if (!response.ok) {
    throw new Error('Network response was not ok.');
  }
  return response.json();
})
.then(data => {
  console.log('Cart updated successfully:', data);
  window.cart_attributes_updated = true;

  // Invoke the callback if it exists and is a function
  if (typeof callback === 'function') {
    callback(null, data); // Pass the data to the callback
  }
})
.catch(error => {
  console.error('Failed to update cart:', error);

  // If there's an error, pass it to the callback
  if (typeof callback === 'function') {
    callback(error);
  }
});
} // gtm_add_cartAttribute()